import React from 'react'
import UserServices from '../../services/UserServices.js';

function ApproveButton({data,page,closeModal,onSuccess}) {
console.log("adsdsdsdsfji",data);

const handleApprove = async () => {
 if (page === 'Vendor') {
    const res = await UserServices.approveVendor(data._id);

    console.warn(res);

    if(res.status === true){
      alert('Approve successfully');
      closeModal();
      onSuccess();
    } 
    else {
      console.log(res)
    }
  }
}
  return (
    <div className="modal fade show d-block" id="deleteACModel" tabIndex="-1" aria-labelledby="deleteACModelLabel" aria-hidden="true">
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content modal-bg-light-green">
          <div className="modal-body py-4 px-5 text-center">
              <h4>Warning !!</h4>
              <p className="desc my-2">Are you sure you want to Approve This Detail ?</p>
              <div className="donate-btn-grp text-center py-4">
                  <button className="site-btn btn-blue delete-btn" onClick={closeModal}>Cancel</button>
                  <button className="site-btn btn-red delete-btn" onClick={handleApprove}>Approve</button>
              </div>
          </div>
      </div>
    </div>
  </div>
  )
}

export default ApproveButton